skrilla.controller('createManualUserTurnoverModalCtrl', function ($scope, searchService, cacheService, modalService, currencyService) {
    $scope.request = cacheService.getObjectOrElse("manualTurnoverRequest", function(){
        modalService.dismissAll();
    });

    $scope.create = function () {
        modalService.confirm("Are you sure you'd like to create this turnover?", function(){
            const request = {...$scope.request, amount : currencyService.multiply($scope.request.amount, $scope.currency)}
            searchService.post("users/" + $scope.request.user.id + "/manualUserTurnover", request, "Manual User Turnover Successfully Created!").then(function(response){
                modalService.dismissAll();
            }, function(){ });
        });
    }
});
